import { CompanyTableInfo } from '@aibees/elephant/feature/search-table-company';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { useMemo } from 'react';

export function useEntityType(item?: CompanyTableInfo | PeopleTableInfo) {
  return useMemo(() => {
    const isCompany = item && isCompanyTableInfo(item);
    const isPeople = item && isPeopleTableInfo(item);
    return { isCompany, isPeople };
  }, [item]);
}

function isCompanyTableInfo(
  item: CompanyTableInfo | PeopleTableInfo
): item is CompanyTableInfo {
  return (
    'summary' in item || 'financial' in item || 'sub_organizations' in item
  );
}

function isPeopleTableInfo(
  item: CompanyTableInfo | PeopleTableInfo
): item is PeopleTableInfo {
  return 'profile' in item || 'positionGroups' in item || 'changes' in item;
}
